export const getUploadErrorTranslationCode = (errorMessage: string): string => {
  const errorMap: Record<string, string> = {
    'payload too large': 'error.imageTooLarge',
  };

  // Try to find a matching error message
  const translationCode = Object.entries(errorMap).find(([key]) =>
    errorMessage.toLowerCase().includes(key.toLowerCase())
  )?.[1];

  // Return the translation code or a generic error if no match is found
  return translationCode || 'error.uploadImage';
};

export const getDisplayErrorMessage = (error: unknown, fallbackMessage: string): string => {
  if (typeof error === 'string') {
    return error;
  }

  if (error instanceof Error && error.message.trim()) {
    return error.message;
  }

  if (typeof error === 'object' && error !== null && 'message' in error) {
    const message = (error as { message?: unknown }).message;
    if (typeof message === 'string' && message.trim()) {
      return message;
    }
  }

  return fallbackMessage;
};
